import { isSamePublishClass } from '@/shared/utils/publish';
import { usePublishedBoxStore } from '@/entities/sets/publish';
import { usePersistStore, useSearchStore } from '@/shared/lib/store';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

export const SearchBarType2 = ({
    tab,
    title,
    placeholder,
    claIdList,
}: {
    tab?: string;
    title: string;
    placeholder: string;
    inputTitle: string;
    claIdList?: API.IntegPubStntClassList.Res;
}) => {
    const queryClient = useQueryClient();
    const { inKeyword, setInKeyword } = useSearchStore();
    const { selectClass, setSearchKeyword, setSearchUserId, setSearchPage } =
        usePublishedBoxStore();
    const { sMyClassMemberList } = usePersistStore();
    const onSearch = () => {
        setSearchKeyword(inKeyword);
        setSearchPage(0);
        queryClient.resetQueries({ queryKey: ['publish-list'] });
        if (tab === '클래스 학생별') {
            inKeyword ? classStntSearch() : setSearchUserId([]);
        }
    };

    const searchClaIdList = selectClass
        ? (claIdList
              ?.filter((e) => isSamePublishClass(e.claId, selectClass.claId))
              .map((e) => e.claId) ?? [])
        : [];

    const classStntSearch = () => {
        const myClassMemberList = sMyClassMemberList?.filter(
            (item) => item.classInfo.classSeq?.toString() === selectClass?.claId.split('-')[4]
        );
        const memberMatched = (myClassMemberList?.[0]?.memberInfo ?? []).filter((m) =>
            m.name?.includes(inKeyword)
        );

        const classSeq = selectClass?.claId?.split('-')[4] ?? '';
        const curriList = (searchClaIdList ?? []).map((id) => id?.split('-')[5]).filter(Boolean);

        const ids = memberMatched.flatMap((m) => {
            const prefix = m.orgMemberId?.split('M')[0]; // 예: sdsolm2510301
            if (!prefix || !classSeq) return [];
            return curriList.map((curri) => `${prefix}-${classSeq}-${curri}`);
        });

        const uniqueIds = Array.from(new Set(ids));
        setSearchUserId(uniqueIds);
    };

    useEffect(() => {
        if (tab === '클래스 학생별') {
            onSearch();
        }
    }, [tab, selectClass]);

    return (
        <div className="search-box // con-mt3">
            <label htmlFor="searchKeyword" className="search-box__label">
                {title}
            </label>
            <input
                id="searchKeyword"
                type="text"
                value={inKeyword}
                placeholder={placeholder}
                className="input-txt"
                style={{ width: '880px' }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        onSearch();
                    }
                }}
                maxLength={200}
                onChange={(e) => setInKeyword(e.target.value)}
            />
            <button className="search-box__btn btn btn-default blue" onClick={onSearch}>
                <i className="base-icon icon-search-w"></i>
                검색
            </button>
        </div>
    );
};
